import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
  DraggableLocation,
} from 'react-beautiful-dnd'
import { KanbanCard } from 'components'
import { icons } from 'helper'
import { KanbanColumn, KanbanContainer } from './style'
import { IKanbanItem, IKanbanColumns } from '../../interfaces'

interface IKanbanProps {
  data: { [key: string]: IKanbanColumns }
  setData(_event?: object): any
  onCardClick?(_event?: object): any
  onCardMove?(_event?: object, _ind?: number): any
  withoutIcon?: boolean
  onDropCard?: any
  noIconCards?: boolean
}

export default function KanbanComponent(props: IKanbanProps) {
  const {
    data,
    setData,
    onCardClick,
    withoutIcon,
    onDropCard,
    onCardMove,
    noIconCards,
  } = props

  // função que muda a ordem dos cards de uma mesma coluna
  const reorder = (
    list: IKanbanItem[],
    startIndex: number,
    endIndex: number
  ) => {
    // clona o array de itens
    const result = [...list]
    // remove o card do array
    const [removed] = result.splice(startIndex, 1)
    // reinsere ele na posição desejada
    result.splice(endIndex, 0, removed)

    return result
  }

  // função que passa um card de uma coluna para outra
  const move = (
    source: IKanbanItem[],
    destination: IKanbanItem[],
    droppableSource: DraggableLocation,
    droppableDestination: DraggableLocation
  ) => {
    const result: { [key: string]: IKanbanItem[] } = {}

    // clona array itens de onde o card foi selecionado
    const sourceClone = [...source]
    // clona array itens para onde o card foi movido
    const destClone = [...destination]
    // retira o card movido do array de origem
    const [removed] = sourceClone.splice(droppableSource.index, 1)
    // insere o card no array de destino
    destClone.splice(droppableDestination.index, 0, removed)

    // retorna o objeto com os 2 novos arrays de itens
    result[droppableSource.droppableId] = sourceClone
    result[droppableDestination.droppableId] = destClone
    return result
  }

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result
    const sourceId = source.droppableId

    if (!destination) {
      return
    }

    const curRule = data[Number(source.droppableId)].moveable
    const destinationIndex = String(data[Number(destination.droppableId)]?.id)

    if (Array.isArray(curRule) && !curRule?.includes(destinationIndex)) {
      return
    }

    const destinationId = destination.droppableId
    if (sourceId === destinationId) {
      // se o id da coluna de origen === coluna de destino...
      //  reordena os cards na coluna
      const items = reorder(
        data[sourceId].items,
        source.index,
        destination.index
      )
      // salva novo estado
      const newState = {
        ...data,
        [sourceId]: { ...data[sourceId], items },
      }
      setData(newState)
    } else {
      // se o id da coluna de origen !== coluna de destino...
      // reordena os cards entre as colunas
      const results = move(
        data[sourceId].items,
        data[destinationId].items,
        source,
        destination
      )

      // chama função onDropCard para mudar o status do card no BD - ex em gestao kanban de gestao de usuarios
      if (onDropCard) {
        const userId = data[sourceId].items[source.index].id
        const columnID = Number(destination.droppableId)
        // console.log(destination)
        onDropCard(userId, columnID, destination)
      }

      onCardMove &&
        onCardMove(
          data[sourceId].items[source.index],
          Number(destination.droppableId)
        )

      // salva novo estado
      const newState = {
        ...data,
        [sourceId]: { ...data[sourceId], items: results[sourceId] },
        [destinationId]: {
          ...data[destinationId],
          items: results[destinationId],
        },
      }
      setData(newState)
    }
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <KanbanContainer>
        {Object.entries(data).map(
          ([columnId, { items, name, icon, color, moveable = true }], ind) => {
            return (
              <Droppable
                droppableId={columnId}
                key={`column-${columnId}-_${ind}`}
              >
                {(provided, _snapshot) => {
                  return (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      <KanbanColumn column={columnId} color="#00000">
                        <span className="columnName" key={Math.random()}>
                          {withoutIcon ? (
                            ''
                          ) : (
                            <img
                              src={icons[icon]}
                              alt="column icon"
                              key={Math.random()}
                            />
                          )}
                          {name}: {items.length}
                        </span>
                        {items.map((item, index) => {
                          return (
                            <Draggable
                              draggableId={String(item.id)}
                              index={index}
                              key={`drag_${item.id}_${index}`}
                            >
                              {(providedDrag, snapshotDrag) => {
                                return !moveable ? (
                                  // COLUNAS BLOQUEADAS
                                  <div ref={providedDrag.innerRef}>
                                    <KanbanCard
                                      color={color}
                                      column={columnId}
                                      cardData={item.cardData}
                                      cpf={item.cpf}
                                      email={item.email}
                                      isDragging={snapshotDrag.isDragging}
                                      lastMessage={item.lastMessage}
                                      name={item.name}
                                      date={item.createdAt}
                                      step={item.step}
                                      noFooter={noIconCards}
                                      onClick={() => {
                                        if (onCardClick) {
                                          onCardClick(item)
                                        }
                                      }}
                                    />
                                  </div>
                                ) : (
                                  // COLUNAS DESBLOQUEADAS
                                  <div
                                    ref={providedDrag.innerRef}
                                    {...providedDrag.draggableProps}
                                    {...providedDrag.dragHandleProps}
                                  >
                                    <KanbanCard
                                      color={color}
                                      column={columnId}
                                      cardData={item.cardData}
                                      cpf={item.cpf}
                                      email={item.email}
                                      isDragging={snapshotDrag.isDragging}
                                      lastMessage={item.lastMessage}
                                      step={item.step}
                                      date={item.createdAt}
                                      noFooter={noIconCards}
                                      onClick={() => {
                                        if (onCardClick) {
                                          onCardClick(item)
                                        }
                                      }}
                                      name={item.name}
                                    />
                                  </div>
                                )
                              }}
                            </Draggable>
                          )
                        })}
                        {provided.placeholder}
                      </KanbanColumn>
                    </div>
                  )
                }}
              </Droppable>
            )
          }
        )}
      </KanbanContainer>
    </DragDropContext>
  )
}
